import { render, staticRenderFns } from "./offer-feedback.vue?vue&type=template&id=21d4aa76"
import script from "./offer-feedback.vue?vue&type=script&lang=js"
export * from "./offer-feedback.vue?vue&type=script&lang=js"
import style0 from "./offer-feedback.vue?vue&type=style&index=0&id=21d4aa76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports